// import { combineReducers } from 'redux';
// import GAME from "./gamestate"

// const koreanApp = combineReducers({
//   GAME
// });

// export default koreanApp;

const initialState = {
  GameOptions: {
    // current_level: 0,
    unlocked_level: 0,
    current_word: 0,
    syllables_complete: 1,
    lives: 3,
    words: [],
    tutorial_seen: false,
    needs_review: false,
  },
};

export default function GAME(state = initialState, action) {
  switch (action.type) {
    case 'SET_GAMEOPTIONS':
      return {
        ...state,
        GameOptions: { ...state.GameOptions, ...action.payload.GameOptions },
      };
    case 'LOAD_STORED_STATE':{
      return {
        ...state,
        GameOptions: { ...state.GameOptions, unlocked_level: action.storedState.token, tutorial_seen: true }
      }
    }
    case 'LOSE_LIFE': {
      return {
        ...state,
        GameOptions: { ...state.GameOptions, lives: state.GameOptions.lives -1 }
      }
    }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/index.js